// Locale / format helpers — Bahasa Indonesia, WIB (Asia/Pontianak), Rupiah

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];

function toParts(iso) {
  const d = new Date(iso);
  // shift to WIB (UTC+7)
  const wib = new Date(d.getTime() + 7 * 3600 * 1000);
  return {
    day: wib.getUTCDate(),
    month: MONTHS[wib.getUTCMonth()],
    year: wib.getUTCFullYear(),
    hour: String(wib.getUTCHours()).padStart(2, "0"),
    min: String(wib.getUTCMinutes()).padStart(2, "0"),
  };
}

export function formatWIB(iso, withTime = true) {
  if (!iso) return "-";
  const p = toParts(iso);
  const base = `${p.day} ${p.month} ${p.year}`;
  return withTime ? `${base}, ${p.hour}:${p.min} WIB` : base;
}

export function rupiah(n) {
  const num = Number(n || 0);
  return "Rp " + num.toLocaleString("id-ID");
}

export function countdown(deadlineIso, status) {
  if (status === "selesai_terverifikasi") return { text: "Selesai", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" };
  if (!deadlineIso) return { text: "Tanpa deadline", cls: "bg-slate-100 text-slate-600 border-slate-200" };
  const now = Date.now();
  const dl = new Date(deadlineIso).getTime();
  const diff = dl - now;
  const abs = Math.abs(diff);
  const days = Math.floor(abs / 86400000);
  const hours = Math.floor((abs % 86400000) / 3600000);
  const mins = Math.floor((abs % 3600000) / 60000);
  let text;
  if (days > 0) text = `${days}h ${hours}j`;
  else if (hours > 0) text = `${hours}j ${mins}m`;
  else text = `${mins}m`;
  if (diff < 0) return { text: `Terlambat ${text}`, cls: "bg-rose-50 text-rose-700 border-rose-200" };
  const cls =
    diff < 24 * 3600000 ? "bg-orange-50 text-orange-700 border-orange-200"
    : diff < 48 * 3600000 ? "bg-amber-50 text-amber-700 border-amber-200"
    : "bg-emerald-50 text-emerald-700 border-emerald-200";
  return { text: `${text} lagi`, cls };
}

export const STATUS_META = {
  draft: { label: "Draft", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  draft_terkunci: { label: "Draft Terkunci", cls: "bg-slate-100 text-slate-500 border-slate-200" },
  ditugaskan: { label: "Ditugaskan", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  diterima: { label: "Diterima", cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  sedang_dikerjakan: { label: "Sedang Dikerjakan", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  menunggu_verifikasi: { label: "Menunggu Verifikasi", cls: "bg-sky-100 text-sky-800 border-sky-300" },
  selesai_terverifikasi: { label: "Selesai Terverifikasi", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  revisi: { label: "Revisi", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  terkendala: { label: "Terkendala", cls: "bg-purple-50 text-purple-700 border-purple-200" },
  menunggu_lintas_divisi: { label: "Menunggu Lintas Divisi", cls: "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200" },
  dibatalkan: { label: "Dibatalkan", cls: "bg-slate-100 text-slate-500 border-slate-200 line-through" },
  tidak_dikerjakan: { label: "Tidak Dikerjakan", cls: "bg-rose-100 text-rose-700 border-rose-300" },
};

export const PROPOSAL_STATUS_META = {
  draft: { label: "Draft", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  dalam_review: { label: "Dalam Review", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  disetujui: { label: "Disetujui", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  disetujui_bersyarat: { label: "Disetujui Bersyarat", cls: "bg-teal-50 text-teal-700 border-teal-200" },
  revisi_diminta: { label: "Revisi Diminta", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  ditolak: { label: "Ditolak", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  ditarik: { label: "Ditarik", cls: "bg-slate-100 text-slate-500 border-slate-200" },
  ditunda: { label: "Ditunda", cls: "bg-orange-50 text-orange-700 border-orange-200" },
};

export const PRIORITY_META = {
  kritis: { label: "Kritis", cls: "bg-rose-600 text-white" },
  tinggi: { label: "Tinggi", cls: "bg-orange-500 text-white" },
  normal: { label: "Normal", cls: "bg-sky-500 text-white" },
  rendah: { label: "Rendah", cls: "bg-slate-400 text-white" },
};

export const HEALTH_META = {
  on_track: { label: "On Track", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  at_risk: { label: "At Risk", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  off_track: { label: "Off Track", cls: "bg-rose-50 text-rose-700 border-rose-200" },
};

export const WORKLOAD_META = {
  rendah: { label: "Rendah", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  optimal: { label: "Optimal", cls: "bg-emerald-100 text-emerald-800 border-emerald-300" },
  tinggi: { label: "Tinggi", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  kelebihan: { label: "Kelebihan Beban", cls: "bg-rose-100 text-rose-800 border-rose-300" },
};

export const ROLE_LABEL = {
  super_admin: "Super Admin",
  owner: "Owner",
  kepala_divisi: "Kepala Divisi",
  atasan: "Atasan",
  staff: "Staff",
  verifikator: "Verifikator",
  auditor: "Auditor",
};
